import { ProjectDocRepository } from "./ProjectDocRepository";

interface FeedbackComment {
  id: string;
  author: string;
  body: string;
  createdAt: number;
}

interface FeedbackTicketLike {
  id: string;
  title: string;
  description: string;
  status: "open" | "done" | "cancelled";
  priority?: "low" | "med" | "high";
  tags?: string[];
  attachments?: string[];
  comments?: FeedbackComment[];
  createdAt: number;
  [key: string]: unknown;
}

class FeedbackRepository extends ProjectDocRepository<FeedbackTicketLike[]> {
  readonly key = "feedback-tickets";
  readonly defaultValue: FeedbackTicketLike[] = [];
}

export const feedbackRepository = new FeedbackRepository();
